var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.277,40.548c-4.109,0-7.452,3.343-7.452,7.452c0,4.109,3.343,7.452,7.452,7.452s7.452-3.343,7.452-7.452 C30.729,43.891,27.386,40.548,23.277,40.548z M23.277,51.452c-1.903,0-3.452-1.549-3.452-3.452s1.549-3.452,3.452-3.452 s3.452,1.549,3.452,3.452S25.18,51.452,23.277,51.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,40.548c-4.109,0-7.452,3.343-7.452,7.452c0,4.109,3.343,7.452,7.452,7.452c4.109,0,7.452-3.343,7.452-7.452 C55.452,43.891,52.109,40.548,48,40.548z M48,51.452c-1.903,0-3.452-1.549-3.452-3.452s1.549-3.452,3.452-3.452 s3.452,1.549,3.452,3.452S49.903,51.452,48,51.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.724,40.548c-4.109,0-7.452,3.343-7.452,7.452c0,4.109,3.343,7.452,7.452,7.452s7.452-3.343,7.452-7.452 C80.176,43.891,76.833,40.548,72.724,40.548z M72.724,51.452c-1.903,0-3.452-1.549-3.452-3.452s1.549-3.452,3.452-3.452 s3.452,1.549,3.452,3.452S74.627,51.452,72.724,51.452z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.835,46h-2.394c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.394c1.104,0,2-0.896,2-2S37.939,46,36.835,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.559,46h-2.394c-1.104,0-2,0.896-2,2s0.896,2,2,2h2.394c1.104,0,2-0.896,2-2S62.663,46,61.559,46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess1);
export default __webpack_public_path__ + "static/media/process-1.76a91e366af1f3d36cd72c7587683201.svg";
export { ForwardRef as ReactComponent };